import { render } from "./AddDomainButton.vue?vue&type=template&id=4276c012"
import script from "./AddDomainButton.vue?vue&type=script&lang=js"
export * from "./AddDomainButton.vue?vue&type=script&lang=js"

import "./AddDomainButton.vue?vue&type=style&index=0&id=4276c012&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__